import { apiRequest } from "../../../shared/api/client";
import {
    WEEKLY_PLANNING_API_BASE,
    weeklyPlanImportResponseSchema,
    weeklyPlanListResponseSchema,
} from "../../../../shared/weekly-planning";
import type { ProductionPlanInspection, ProductionPlanPreview, SavedProductionPlan, SavedProductionPlanDetail, ActiveRequest, RequestBatchResponse, PlanRequestBatchInput } from "./plan-import-types";
export const planImportGateway = {
    listSavedPlans: () => apiRequest<{
        items: SavedProductionPlan[];
    }>("/api/integrations/production/mikro/production-plans?history=1"),
    loadSavedPlan: (planId: string) => apiRequest<SavedProductionPlanDetail>(`/api/integrations/production/mikro/production-plans/${planId}`),
    refreshSavedPlan: (planId: string) => apiRequest<SavedProductionPlanDetail>(`/api/integrations/production/mikro/production-plans/${planId}/refresh`, { method: "POST" }),
    inspect: (body: FormData) => apiRequest<ProductionPlanInspection>("/api/integrations/production/mikro/production-plan/inspect", { method: "POST", body }),
    preview: (body: FormData) => apiRequest<ProductionPlanPreview>("/api/integrations/production/mikro/production-plan/preview", { method: "POST", body }),
    weeklyDraftForWeek: async (weekStart: string) => {
        const raw = await apiRequest<unknown>(`${WEEKLY_PLANNING_API_BASE}/plans?${new URLSearchParams({ weekStart, history: "1" })}`);
        return weeklyPlanListResponseSchema.parse(raw).items.find((plan) => plan.status === "DRAFT") ?? null;
    },
    importWeeklyDraft: async (body: FormData) => {
        const raw = await apiRequest<unknown>("/api/integrations/production/mikro/production-plan/weekly-draft", { method: "POST", body });
        return weeklyPlanImportResponseSchema.parse(raw);
    },
    activeRequests: (materialCodes: string[]) => apiRequest<{
        items: ActiveRequest[];
    }>("/api/integrations/production/mikro/production-plan/active-requests", { method: "POST", body: JSON.stringify({ materialCodes }) }),
    saveBatch: (idempotencyKey: string, payload: PlanRequestBatchInput) => apiRequest<RequestBatchResponse>("/api/production-plan-request-batches", { method: "POST", headers: { "idempotency-key": idempotencyKey }, body: JSON.stringify(payload) }),
    submitBatch: (batchId: string) => apiRequest<RequestBatchResponse>(`/api/production-plan-request-batches/${batchId}/submit`, { method: "POST" }),
};
